import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Link,
  Button,
  Divider,
  TextField,
  Popover,
} from "@mui/material";

import React, {
  useEffect,
  useState,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { sbHeightCtx } from "../../store/sidebarWiHeContext";
import {
  lightBlue,
  grey,
  green,
  blue,
  teal,
  red,
  yellow,
  purple,
} from "@mui/material/colors";
import axios from "axios";
import excel_up from "../../image/excel_up.jpeg";
import excel_down from "../../image/excel_down.png";
import ListIcon from "@mui/icons-material/List";
import UploadIcon from "@mui/icons-material/Upload";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import cls from "./Status.module.css";
import MFexlinput from "../Modal/MflistExcelinput";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { useOneEffect } from "../useOneEffect";
import ExcelJS from "exceljs";
import dayjs from "dayjs";
import RdvAttendancePanel from "./RdvAttendancePanel";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import StatusTimelineBar from "./StatusTimelineBar";
import DiffBadge from "../common/DiffBadge";
import {
  buildDiffMap,
  buildSparklineData,
  EQUIP_COLS,
  DIFF_DISPLAY_MS,
  resolveMinuteSnapshot,
  resolveMinuteSignboard,
  prevMinuteSnapshotKey,
  computeSignboardDiff,
  getTimelineNowBound,
  clampTimelineSelection,
} from "../../lib/statusBoardDiff";
import { LineChart, Line, ResponsiveContainer } from "recharts";

const TIMELINE_HOURS = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
/** 상태 변경 직후 onmflist가 잠깐 빈 배열을 주는 타이밍 이슈 회피 (Home 사인보드 200ms 지연과 동일 목적) */
const STATE_SYNC_REFETCH_MS = 400;

const dispatchTimelineSignboard = (signboard, prevSignboard, active) => {
  if (typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(
    new CustomEvent("statusTimelineSignboard", {
      detail: {
        active: !!active,
        signboard: signboard || null,
        diff: computeSignboardDiff(prevSignboard, signboard),
      },
    }),
  );
};

const dispatchTimelineMfList = (active, ctx = {}) => {
  if (typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(
    new CustomEvent("statusTimelineMfList", {
      detail: { active: !!active, ...ctx },
    }),
  );
};

const excelbtn = {
  width: 30,
  height: 25,
  border: "solid 1px yellow",
  borderRadius: 3,
  "&:hover": {
    backgroundColor: green[300],
    pointer: "cursor",
  },
  // backgroundColor: "white",
  zIndex: 10,
};

// 상황판 헤더 스타일
const statusTitle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: "bold",
  backgroundColor: red[900],
  color: "white",
  padding: "0 8px",
  height: "40px",
  minHeight: "40px",
  boxSizing: "border-box",
  fontSize: "1.25rem",
};

// 상황판 헤더 스타일 그레이
const statusTitleG = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  fontWeight: "bold",
  backgroundColor: grey[500],
  color: "white",
  padding: "0 8px",
  height: "53px",
  minHeight: "53px",
  boxSizing: "border-box",
  fontSize: "1.25rem",
};

const tblstyle = { // 테이블 헤더 스타일 - 컬럼명 버튼 셀 간격 최소화
  position: "sticky",
  top: 0,
  fontWeight: "bold",
  backgroundColor: red[400],
  color: "white",
  textAlign: "center",
  paddingLeft: "2px",
  paddingRight: "2px",
};
const tblstyleG = {  // 테이블 헤더 스타일 그레이
  fontWeight: "bold",
  backgroundColor: grey[400],
  color: "white",
  textAlign: "center",
  paddingLeft: "2px",
  paddingRight: "2px",
};

const rowstyle = { // 테이블 행 스타일
  fontWeight: "bold",
  color: "black",
  border: "solid 1px black",
  fontSize: "0.9rem",
  textAlign: "center",
  paddingLeft: 0.5,
  paddingRight: 0.5,
  marginLeft: -1,
  marginRight: -1,
  marginTop: -0.3,
  marginBottom: -0.3,
  borderRadius: 1,
  "&:hover": {
    backgroundColor: green[300],
  },
};

const rowstyleG = { // 테이블 행 스타일 그레이
  fontWeight: "bold",
  color: "white",
  border: "solid 1px black",
  textAlign: "center",
};
const volbgc = {
  position: "sticky",
  top: 0,
  fontWeight: "bold",
  backgroundColor: red[200],
  color: "white",
  textAlign: "center",
  paddingLeft: "2px",
  paddingRight: "2px",
};
const volbgcG = { // 테이블 헤더 스타일 그레이
  fontWeight: "bold",
  backgroundColor: grey[300],
  color: "white",
  textAlign: "center",
  paddingLeft: "2px",
  paddingRight: "2px",
};

const eqpBtn = { // 소방계(장비/인원) 버튼 스타일 - 간격 최소화
  fontSize: "0.9rem",
  fontWeight: "bold",
  color: "white",
  border: "solid 1px black",
  borderRadius: 1,
  lineHeight: 1,
  // padding: "2px 4px", // 최대한 좁게
  paddingLeft: "6px",
  paddingRight: "6px",
  paddingTop: "4px",
  paddingBottom: "4px",
  minWidth: "unset",
  display: "inline-block",
  verticalAlign: "middle",
  height: "auto",
  "&:hover": {
    backgroundColor: green[300],
  },
  cursor: "pointer",
};

const bcd = teal[50]; // 데이터 셀 배경색
//let bgcF,  bgcV = ""; // 배경색 변수

// 데이터 셀 스타일
const dcell = {
  textAlign: "center",
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  marginLeft: -1,
  marginRight: -1,
  backgroundColor: teal[100],
};

// 데이터 셀 숫자 스타일
const cellnum = {
  fontSize: "0.9rem",
  border: "dotted 1px black",
  paddingLeft: 3,
  paddingRight: 3,
  borderRadius: 3,
};

// 툴팁 스타일
const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 12,
  },
}));

// 오늘 날짜 반환
const getTodayYYYYMMDD = () => new Date().toISOString().slice(0, 10);

// 달력 강조용 서버 날짜
function ServerDay(props) {
  const { datesWithData = [], inferredEndDate, day, ...other } = props;
  const dateStr = dayjs(day).format("YYYY-MM-DD");
  const isDataDay = datesWithData.includes(dateStr);
  const isAfterInferred =
    inferredEndDate && dateStr > inferredEndDate && isDataDay;
  return (
    <PickersDay
      {...other}
      day={day}
      sx={{
        ...(isDataDay && {
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 4,
            right: 4,
            width: 6,
            height: 6,
            borderRadius: "50%",
            backgroundColor: isAfterInferred
              ? "rgba(25, 118, 210, 0.35)"
              : "primary.main",
          },
        }),
      }}
    />
  );
}

function MiniSparkline({ data }) {
  if (!data || data.length < 2) return null;
  return (
    <span className={cls.sparklineWrap}>
      <ResponsiveContainer width={56} height={18}>
        <LineChart data={data}>
          <Line
            type="monotone"
            dataKey="value"
            stroke="#1565c0"
            dot={false}
            strokeWidth={1.5}
            isAnimationActive={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </span>
  );
}

// 상황판 컴포넌트
const StatusPanel = (props) => {
  const { onSelectDS } = useContext(sbHeightCtx);
  const [mfdata, setmfData] = useState([]);
  const [isdata, setIsdata] = useState(false); // 데이터가 있는지 여부 목록표출
  const [checked, setChecked] = useState(true); // 상황판 보기/숨기기
  const [showCompact, setShowCompact] = useState(false); // 3줄 보기 토글
  const [showReview, setShowReview] = useState(false); // 시간별 리뷰(타임라인) 표시
  const [selectedDate, setSelectedDate] = useState(getTodayYYYYMMDD);
  const [datesWithData, setDatesWithData] = useState([]);
  const [calendarAnchorEl, setCalendarAnchorEl] = useState(null);
  const [calendarViewDate, setCalendarViewDate] = useState(() =>
    dayjs(getTodayYYYYMMDD()),
  );
  const [viewMode, setViewMode] = useState("live");
  const [selectedHour, setSelectedHour] = useState(9);
  const [selectedMinute, setSelectedMinute] = useState(0);
  const [isPlayingHour, setIsPlayingHour] = useState(false);
  const [isPlayingMinute, setIsPlayingMinute] = useState(false);
  const [seriesCache, setSeriesCache] = useState({});
  const [minuteSeriesCache, setMinuteSeriesCache] = useState({});
  const [changedHours, setChangedHours] = useState([]);
  const [changedMinutes, setChangedMinutes] = useState([]);
  const [prevSnapshot, setPrevSnapshot] = useState(null);
  const [diffMap, setDiffMap] = useState({});
  const [inferredMeta, setInferredMeta] = useState(null);
  const [staleBannerDismissed, setStaleBannerDismissed] = useState(false);
  const appliedStaleDateRef = useRef(false);
  const mfdataRef = useRef([]);
  const diffClearTimerRef = useRef(null);
  const liveFetchRetryRef = useRef(0);
  const fetchDataRef = useRef(() => {});
  const blinkTimersRef = useRef([]);

  const scheduleDiffClear = useCallback(() => {
    if (diffClearTimerRef.current) clearTimeout(diffClearTimerRef.current);
    diffClearTimerRef.current = setTimeout(() => {
      setDiffMap({});
      diffClearTimerRef.current = null;
    }, DIFF_DISPLAY_MS);
  }, []);

  const fetchDatesWithData = useCallback(
    async (yearMonth) => {
      const dsid = sessionStorage.ondsid;
      if (!dsid || !props.apiAddr || !yearMonth) return;
      const [y, m] = yearMonth.split("-").map(Number);
      try {
        const res = await axios.get(
          `${props.apiAddr}/get/dateswithdata?dsid=${encodeURIComponent(dsid)}&year=${y}&month=${m}`,
        );
        const data = res.data || [];
        setDatesWithData(
          Array.isArray(data)
            ? data
                .map((r) => (r.date != null ? String(r.date).slice(0, 10) : ""))
                .filter(Boolean)
            : [],
        );
      } catch (e) {
        setDatesWithData([]);
      }
    },
    [props.apiAddr],
  );

  const fetchInferredMeta = useCallback(async () => {
    const dsid = sessionStorage.ondsid;
    if (!dsid || !props.apiAddr) return;
    try {
      const res = await axios.get(
        `${props.apiAddr}/get/dsinferredmeta?dsid=${encodeURIComponent(dsid)}`,
      );
      setInferredMeta(res.data || null);
      if (
        res.data?.isStale &&
        res.data?.inferredEndDate &&
        !appliedStaleDateRef.current
      ) {
        appliedStaleDateRef.current = true;
        setSelectedDate(res.data.inferredEndDate);
        setCalendarViewDate(dayjs(res.data.inferredEndDate));
        setViewMode("hourly");
        setSelectedHour(23);
      }
    } catch (e) {
      setInferredMeta(null);
    }
  }, [props.apiAddr]);

  const fetchTimeSeries = useCallback(
    async (date) => {
      const dsid = sessionStorage.ondsid;
      if (!dsid || !props.apiAddr || !date) return null;
      try {
        const res = await axios.get(
          `${props.apiAddr}/get/onmflistdailytimeseries?dsid=${encodeURIComponent(dsid)}&date=${encodeURIComponent(date)}`,
        );
        const data = res.data || {};
        setSeriesCache((prev) => ({ ...prev, [date]: data }));
        setChangedHours(data.changedHours || []);
        return data;
      } catch (e) {
        return null;
      }
    },
    [props.apiAddr],
  );

  const fetchMinuteSeries = useCallback(
    async (date, hour) => {
      const dsid = sessionStorage.ondsid;
      if (!dsid || !props.apiAddr || !date || hour == null) return null;
      const cacheKey = `${date}-${hour}`;
      try {
        const res = await axios.get(
          `${props.apiAddr}/get/onmflisthourminuteseries?dsid=${encodeURIComponent(dsid)}&date=${encodeURIComponent(date)}&hour=${hour}`,
        );
        const data = res.data || {};
        setMinuteSeriesCache((prev) => ({ ...prev, [cacheKey]: data }));
        setChangedMinutes(data.changedMinutes || []);
        return data;
      } catch (e) {
        setChangedMinutes([]);
        return null;
      }
    },
    [props.apiAddr],
  );

  const applySnapshot = useCallback((rows, prevRows) => {
    const tmp = Array.isArray(rows) ? [...rows] : [];
    if (tmp.length > 0 && tmp[tmp.length - 1]?.org !== "sum") {
      // already normalized
    } else if (tmp.length > 0) {
      // rows from API may need sum first - timeseries already normalized
    }
    let normalized = tmp;
    if (normalized.length > 1 && normalized[0]?.org !== "sum") {
      normalized = [...tmp];
      if (normalized[normalized.length - 1]?.org === "sum" || normalized[normalized.length - 1]?.org == null) {
        const sumRow = normalized.pop();
        normalized.unshift(sumRow);
      }
    }
    setPrevSnapshot(prevRows || null);
    setDiffMap(buildDiffMap(prevRows, normalized, EQUIP_COLS));
    if (normalized.length > 1) {
      setmfData(normalized);
      setIsdata(true);
    } else {
      setmfData(normalized.length ? normalized : []);
      setIsdata(normalized.length > 1);
    }
  }, []);

  useEffect(
    () => () => {
      if (diffClearTimerRef.current) clearTimeout(diffClearTimerRef.current);
      blinkTimersRef.current.forEach((id) => clearTimeout(id));
      blinkTimersRef.current = [];
    },
    [],
  );

  // 동원자원 목록 가져오기
  const fetchData = useCallback(
    async (options = {}) => {
      const { withLiveDiff = false } = options;
      const dsid = sessionStorage.ondsid;
      if (!dsid) return;
      const isToday = selectedDate === getTodayYYYYMMDD();

      if (viewMode === "live" && isToday) {
        try {
          const result = await axios.get(
            `${props.apiAddr}/get/onmflist?dsid=${dsid}`,
          );
          let tmp = result.data || [];
          if (Array.isArray(tmp) && tmp.length > 0) tmp.unshift(tmp.pop());
          const prevRows = mfdataRef.current;
          if (
            withLiveDiff &&
            tmp.length <= 1 &&
            prevRows.length > 1
          ) {
            if (liveFetchRetryRef.current < 2) {
              liveFetchRetryRef.current += 1;
              setTimeout(
                () => fetchData({ withLiveDiff: true }),
                STATE_SYNC_REFETCH_MS,
              );
            }
            return;
          }
          liveFetchRetryRef.current = 0;
          if (withLiveDiff && prevRows.length > 0) {
            setDiffMap(buildDiffMap(prevRows, tmp, EQUIP_COLS));
            scheduleDiffClear();
          } else if (!withLiveDiff) {
            setDiffMap({});
          }
          mfdataRef.current = tmp;
          if (tmp.length > 1) {
            setmfData(tmp);
            setIsdata(true);
          } else {
            setmfData(tmp.length ? tmp : []);
            setIsdata(tmp.length > 1);
          }
        } catch (err) {
          console.error(err);
          setmfData([]);
          setIsdata(false);
        }
        return;
      }

    if (viewMode === "hourly") {
      const series =
        seriesCache[selectedDate] || (await fetchTimeSeries(selectedDate));
      const cacheKey = `${selectedDate}-${selectedHour}`;
      let minuteSeries = minuteSeriesCache[cacheKey];
      if (!minuteSeries) {
        minuteSeries = await fetchMinuteSeries(selectedDate, selectedHour);
      }
      const minute = selectedMinute ?? 0;
      let rows;
      let prevRows;
      let currentSignboard = null;
      let prevSignboard = null;
      if (minuteSeries?.minutes?.length) {
        rows = resolveMinuteSnapshot(minuteSeries, minute);
        currentSignboard = resolveMinuteSignboard(minuteSeries, minute);
        const prevMinKey = prevMinuteSnapshotKey(minuteSeries, minute);
        if (prevMinKey != null) {
          prevRows = minuteSeries.snapshots[String(prevMinKey)] || null;
          prevSignboard = minuteSeries.signboards?.[String(prevMinKey)] || null;
        } else {
          const hourIdx = TIMELINE_HOURS.indexOf(selectedHour);
          const prevHour =
            hourIdx > 0 ? TIMELINE_HOURS[hourIdx - 1] : null;
          prevRows = prevHour
            ? series?.snapshots?.[String(prevHour)] || null
            : null;
          prevSignboard = prevHour
            ? series?.signboards?.[String(prevHour)] || null
            : null;
        }
      } else {
        const hourKey = String(selectedHour);
        rows = series?.snapshots?.[hourKey] || [];
        currentSignboard = series?.signboards?.[hourKey] || null;
        const hourIdx = TIMELINE_HOURS.indexOf(selectedHour);
        const prevHour =
          hourIdx > 0 ? TIMELINE_HOURS[hourIdx - 1] : null;
        prevRows = prevHour
          ? series?.snapshots?.[String(prevHour)] || null
          : null;
        prevSignboard = prevHour
          ? series?.signboards?.[String(prevHour)] || null
          : null;
      }
      applySnapshot(rows, prevRows);
      dispatchTimelineSignboard(currentSignboard, prevSignboard, true);
      dispatchTimelineMfList(true, {
        date: selectedDate,
        hour: selectedHour,
        minute: selectedMinute ?? 0,
      });
      return;
    }

    dispatchTimelineSignboard(null, null, false);
    dispatchTimelineMfList(false);

    // daily (전체)
    let wstring;
    if (isToday) {
      wstring = `${props.apiAddr}/get/onmflist?dsid=${dsid}`;
    } else {
      wstring = `${props.apiAddr}/get/onmflistdaily?dsid=${dsid}&date=${selectedDate}`;
    }
    try {
      const result = await axios.get(wstring);
      let tmp = result.data || [];
      if (Array.isArray(tmp) && tmp.length > 0) tmp.unshift(tmp.pop());
      setPrevSnapshot(null);
      setDiffMap({});
      if (tmp.length > 1) {
        setmfData(tmp);
        setIsdata(true);
      } else {
        setmfData(tmp.length ? tmp : []);
        setIsdata(tmp.length > 1);
      }
    } catch (err) {
      console.error(err);
      setmfData([]);
      setIsdata(false);
    }
  }, [
    selectedDate,
    viewMode,
    selectedHour,
    selectedMinute,
    props.apiAddr,
    seriesCache,
    minuteSeriesCache,
    fetchTimeSeries,
    fetchMinuteSeries,
    applySnapshot,
    scheduleDiffClear,
  ]);

  useEffect(() => {
    appliedStaleDateRef.current = false;
    setSeriesCache({});
    setMinuteSeriesCache({});
    setChangedMinutes([]);
    setStaleBannerDismissed(false);
    mfdataRef.current = [];
    setDiffMap({});
    sessionStorage.selectedOrg = "";
    sessionStorage.selectedEqp = "";
    fetchInferredMeta();
  }, [onSelectDS, fetchInferredMeta]);

  useEffect(() => {
    fetchDataRef.current = fetchData;
  }, [fetchData]);

  useEffect(() => {
    fetchData();
  }, [onSelectDS, selectedDate, viewMode, selectedHour, selectedMinute, fetchData]);

  useEffect(() => {
    if (viewMode === "hourly") return;
    dispatchTimelineSignboard(null, null, false);
    dispatchTimelineMfList(false);
  }, [viewMode]);

  useEffect(() => {
    if (viewMode !== "hourly") {
      setChangedMinutes([]);
      return;
    }
    setSelectedMinute(0);
    fetchMinuteSeries(selectedDate, selectedHour);
  }, [viewMode, selectedDate, selectedHour, fetchMinuteSeries]);

  const handleRefresh = async () => {
    // 상황판 갱신 함수
    await fetchData();
    if (sessionStorage.StatusPanel == "true") {
      changedNum();
    }
  };

  const orgBtnClickHandler = (e) => {
    // 기관버튼 클릭시 해당 기관의 동원자원 목록 가져오기
    sessionStorage.selectedOrg = e.target.id;
    sessionStorage.selectedEqp = "";
    setShowCompact(true); // 3줄 보기 먼저 실행
    props.mflist(); // 동원자원 목록 프롭 호출
    props.viewmf(); // 동원자원 목록 표출 여부 프롭 호출
  };

  const eqpBtnHandler = (e) => {
    // 펌프, 물탱크 버튼 클릭시 해당 기관의 동원자원 목록 가져오기
    sessionStorage.selectedEqp = e.target.textContent;
    sessionStorage.selectedOrg = "";
    setShowCompact(true); // 3줄 보기 먼저 실행
    props.mflist(); // 동원자원 목록 프롭 호출
    props.viewmf(); // 동원자원 목록 표출 여부 프롭 호출
  };

  useEffect(() => {
    if (sessionStorage.StatusPanel != "true") return;
    sessionStorage.chedTimeStamp = new Date()
      .toISOString()
      .replace(/[-:T]/g, "")
      .replace(/\..+/, "")
      .slice(0, 14);
    if (typeof window.dispatchEvent === "function") {
      window.dispatchEvent(new CustomEvent("chedTimeStampUpdated"));
    }
    liveFetchRetryRef.current = 0;
    const timer = setTimeout(async () => {
      if (viewMode === "hourly") {
        setSeriesCache({});
        setMinuteSeriesCache({});
        await fetchMinuteSeries(selectedDate, selectedHour);
        await fetchDataRef.current();
      } else if (
        viewMode === "live" &&
        selectedDate === getTodayYYYYMMDD()
      ) {
        await fetchDataRef.current({ withLiveDiff: true });
      }
      requestAnimationFrame(() => changedNum());
    }, STATE_SYNC_REFETCH_MS);
    return () => clearTimeout(timer);
  }, [props.statechanged, viewMode, selectedDate]);

  useEffect(() => {
    sessionStorage.StatusPanel = true;
  }, []);

  useEffect(() => {
    const onDetailClosed = () => setShowCompact(false);
    window.addEventListener("mfDetailClosed", onDetailClosed);
    return () => window.removeEventListener("mfDetailClosed", onDetailClosed);
  }, []);

  const clearBlinkTimers = () => {
    blinkTimersRef.current.forEach((id) => clearTimeout(id));
    blinkTimersRef.current = [];
  };

  const scheduleBlinkRemove = (el) => {
    if (!el) return;
    const id = setTimeout(() => {
      el.classList.remove(cls.blackblink);
      blinkTimersRef.current = blinkTimersRef.current.filter((t) => t !== id);
    }, 2200);
    blinkTimersRef.current.push(id);
  };

  const changedNum = () => {
    // 상황판 갱신항목 선별 배경반전
    const table = document.getElementById("statusTable");

    // 테이블이 존재하지 않으면 함수 종료
    if (!table || !table.rows || table.rows.length === 0) {
      console.warn("statusTable이 아직 렌더링되지 않았습니다.");
      return;
    }

    clearBlinkTimers();
    const org = sessionStorage.refreshOrg;
    const eqp = sessionStorage.refreshEqp;
    let xval,
      yval = "";

    // 테이블 첫열의 값을 org와 비교하여 같으면 배경색을 변경
    for (let i = 1; i < table.rows.length; i++) {
      if (!table.rows[i] || !table.rows[i].cells || !table.rows[i].cells[0]) {
        continue;
      }
      const xcells = table.rows[i].cells[0];
      if (xcells && xcells.textContent == org) {
        if (xcells.children && xcells.children[0]) {
          xcells.children[0].classList.remove(cls.blackblink);
          xcells.children[0].classList.add(cls.blackblink);
          scheduleBlinkRemove(xcells.children[0]);
          //선택된 td안의 span 요소의 백경을 바꿈
          xval = i;
        }
      }
    }

    // 테이블 첫행의 값을 eqp와 비교하여 같으면 배경색을 변경
    if (table.rows[0] && table.rows[0].cells) {
      for (let i = 1; i < table.rows[0].cells.length; i++) {
        if (!table.rows[0].cells[i]) {
          continue;
        }
        const ycells = table.rows[0].cells[i];
        if (ycells && ycells.textContent == eqp) {
          if (ycells.children && ycells.children[0]) {
            ycells.children[0].classList.remove(cls.blackblink);
            ycells.children[0].classList.add(cls.blackblink);
            scheduleBlinkRemove(ycells.children[0]);
            yval = i;
          }
        }
      }
    }

    if (sessionStorage.refreshSort == "input" && xval && yval) {
      if (
        table.rows[xval] &&
        table.rows[xval].cells &&
        table.rows[xval].cells[yval] &&
        table.rows[xval].cells[yval].children &&
        table.rows[xval].cells[yval].children[0]
      ) {
        const crossCell = table.rows[xval].cells[yval].children[0];
        crossCell.classList.remove(cls.blackblink);
        crossCell.classList.add(cls.blackblink);
        scheduleBlinkRemove(crossCell);
        if (
          table.rows[1] &&
          table.rows[1].cells &&
          table.rows[1].cells[1] &&
          table.rows[1].cells[1].children &&
          table.rows[1].cells[1].children[0]
        ) {
          const sumCell = table.rows[1].cells[1].children[0];
          sumCell.classList.remove(cls.blackblink);
          sumCell.classList.add(cls.blackblink);
          scheduleBlinkRemove(sumCell);
        }
      }
    }
  };

  //일괄입력 엑셀서식 다운로드 (신규 서식: public/mfm_template.xlsx)
  const docdownClickHandler = async () => {
    try {
      const hq = localStorage.hq?.trim() || "";

      // 자원집결지 목록 가져오기 (list 시트 D열 채우기용) — 타임아웃으로 무한 대기 방지
      let rdvList = [];
      try {
        const rdvResponse = await axios.get(`${props.apiAddr}/get/getrdvlist`, {
          timeout: 8000,
        });
        rdvList = (rdvResponse.data || [])
          .filter((item) => (item.hq || "").toString().trim() === hq)
          .map((item) => item.rname);
      } catch (_) {}

      // 신규 서식 템플릿 로드: API 경로 우선, 실패/타임아웃 시 같은 오리진 정적 파일 폴백
      const FETCH_TIMEOUT_MS = 10000;
      let res;
      let arrayBuffer;
      let contentType = "";
      const apiTemplateUrl = `${props.apiAddr}/get/mfm_template`;
      console.log("apiTemplateUrl", apiTemplateUrl);
      try {
        const ac = new AbortController();
        const toId = setTimeout(() => ac.abort(), FETCH_TIMEOUT_MS);
        res = await fetch(apiTemplateUrl, { signal: ac.signal });
        clearTimeout(toId);
        contentType = res.headers.get("Content-Type") || "";
        arrayBuffer = await res.arrayBuffer();
      } catch (apiErr) {
        const isNetworkErr =
          apiErr?.name === "AbortError" ||
          apiErr?.message === "Failed to fetch" ||
          apiErr?.name === "TypeError";
        if (!isNetworkErr) throw apiErr;
        const fallbackUrl =
          `${process.env.PUBLIC_URL || ""}/mfm_template.xlsx`.replace(
            /^\/+/,
            "/",
          ) || "/mfm_template.xlsx";
        res = await fetch(fallbackUrl);
        if (!res.ok)
          throw new Error(
            "서식 파일을 불러올 수 없습니다. (API 및 같은 주소 폴백 모두 실패)",
          );
        contentType = res.headers.get("Content-Type") || "";
        arrayBuffer = await res.arrayBuffer();
      }
      if (!res.ok) throw new Error("서식 파일을 불러올 수 없습니다.");
      if (
        arrayBuffer.byteLength === 0 ||
        (!contentType.includes("spreadsheet") &&
          !contentType.includes("octet-stream"))
      ) {
        throw new Error(
          "서식 파일 형식이 올바르지 않습니다. 서버에 mfm_template.xlsx가 있는지 확인해 주세요.",
        );
      }

      const workbook = new ExcelJS.Workbook();
      await workbook.xlsx.load(arrayBuffer);

      // list 시트가 있으면 D열에 자원집결지 목록 채우기
      const listSheet = workbook.getWorksheet("list");
      if (listSheet && rdvList.length > 0) {
        rdvList.forEach((rdv, index) => {
          const cell = listSheet.getCell(index + 2, 4); // D열 = 4
          if (cell) cell.value = rdv;
        });
      }

      // 동원자원입력 시트: list A→B, B→E, C→H, D→K 드롭다운
      const inputSheet = workbook.getWorksheet("동원자원입력");
      const lastListRow = rdvList.length > 0 ? rdvList.length + 1 : 2;
      const listRangeA = "list!$A$2:$A$30";
      const listRangeB = "list!$B$2:$B$30";
      const listRangeC = "list!$C$2:$C$30";
      const listRangeD = `list!$D$2:$D$${lastListRow}`;
      if (inputSheet) {
        const dataRowEnd = 200;
        for (let r = 2; r <= dataRowEnd; r++) {
          const bCell = inputSheet.getCell(r, 2); // B열 = 2
          if (bCell) {
            bCell.dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: [listRangeA],
            };
          }
          const eCell = inputSheet.getCell(r, 5); // E열 = 5
          if (eCell) {
            eCell.dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: [listRangeB],
            };
          }
          const hCell = inputSheet.getCell(r, 8); // H열 = 8
          if (hCell) {
            hCell.dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: [listRangeC],
            };
          }
          const kCell = inputSheet.getCell(r, 11); // K열 = 11
          if (kCell) {
            kCell.dataValidation = {
              type: "list",
              allowBlank: true,
              formulae: [listRangeD],
            };
          }
        }
      }

      const fileName = hq === "cn" ? "mfmcn.xlsx" : "mfm.xlsx";
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("파일 생성 중 오류 발생:", error);
      alert("파일 생성 중 오류가 발생했습니다.");
    }
  };

  const excelUploadClickHandler = () => {
    // 파일 선택창을 바로 띄우지 않고, 일괄입력 모달을 먼저 연다.
    callMFexlinputModal();
  };

  const callMFexlinputModal = () => {
    // 동원자원 엑셀파일 입력 모달 호출
    sessionStorage.modalSort = "MFexcelinput";
    props.onShowDS();
  };

  const tableToExcelExport = async () => {
    try {
      // 데이터 존재 여부 먼저 확인
      if (!isdata) {
        alert("자료가 없습니다.");
        return;
      }

      const table = document.getElementById("statusTable");
      if (!table) throw new Error("테이블을 찾을 수 없습니다");

      const data = Array.from(table.rows).map((row) =>
        Array.from(row.cells).map((cell) => cell.textContent.trim()),
      );

      // ExcelJS를 사용하여 워크북 생성
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("상황판");

      // 데이터를 워크시트에 추가
      data.forEach((row) => {
        worksheet.addRow(row);
      });

      // 엑셀 파일 다운로드
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "상황판.xlsx";
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("엑셀 변환 중 오류 발생:", error);
      alert("엑셀 파일 생성 중 오류가 발생했습니다.");
    }
  };

  const handleReviewToggle = () => {
    const next = !showReview;
    setShowReview(next);
    setIsPlayingHour(false);
    setIsPlayingMinute(false);
    if (next) {
      setViewMode("hourly");
      setShowCompact(true);
      const isToday = selectedDate === getTodayYYYYMMDD();
      const clamped = clampTimelineSelection(
        selectedHour ?? 9,
        0,
        isToday,
        TIMELINE_HOURS,
      );
      setSelectedHour(clamped.hour);
      setSelectedMinute(clamped.minute);
    } else {
      setViewMode(
        selectedDate === getTodayYYYYMMDD() ? "live" : "daily",
      );
      setShowCompact(false);
      dispatchTimelineMfList(false);
    }
  };

  const handleChange = (e) => {
    // 상황판 보기/숨기기
    setChecked(e.target.checked);
    if (!e.target.checked) {
      setShowCompact(false); // 상황판 숨길 때 3줄 보기도 초기화
      setShowReview(false);
      setIsPlayingHour(false);
      setIsPlayingMinute(false);
    }
    sessionStorage.StatusPanel = e.target.checked;
    props.hidemf(); // 동원자원 목록 숨기기 프롭 호출
  };

  useOneEffect(() => {
    // 전체보기/숨기기 프롭처리
    // 상황판 보기/숨기
    const ox = props.fullswitch;
    // 상황판 보기/숨기기
    setChecked(ox);
    sessionStorage.StatusPanel = ox;
    props.hidemf(); // 동원자원 목록 숨기기 프롭 호출
  }, [props.fullswitch]);

  // 컬럼 데이터 존재 여부를 확인하는 함수 추가
  const checkColumnHasData = useCallback(
    (columnName) => {
      return mfdata.some(
        (item) => item[columnName] && item[columnName] !== "0/0",
      );
    },
    [mfdata],
  );

  // 컬럼 정의 객체 추가
  const columns = useMemo(
    () => [
      { id: "pump", label: "펌프" },
      { id: "tank", label: "물탱크" },
      { id: "chem", label: "화학" },
      { id: "humg", label: "험지" },
      { id: "rscu", label: "구조" },
      { id: "emer", label: "구급" },
      { id: "heli", label: "헬기" },
      { id: "control", label: "지휘" },
      { id: "admin", label: "행정" },
      { id: "recovery", label: "회복" },
      { id: "satellite", label: "위성" },
      { id: "etcar", label: "기타차량" },
      { id: "volunteer", label: "의소대", isSupport: true },
      { id: "police", label: "경찰", isSupport: true },
      { id: "military", label: "군", isSupport: true },
      { id: "official", label: "공무원", isSupport: true },
      { id: "etc", label: "기타", isSupport: true },
    ],
    [],
  );

  // 표시할 컬럼 필터링
  const visibleColumns = useMemo(() => {
    return columns.filter((column) => checkColumnHasData(column.id));
  }, [columns, checkColumnHasData]);

  // 1. 먼저 calculateTotalCount 함수 선언
  const calculateTotalCount = useCallback(
    (item) => {
      const equipmentTotal = visibleColumns
        .filter((col) => !col.isSupport)
        .reduce(
          (acc, col) => {
            const [count, total] = item[col.id].split("/").map(Number);
            return {
              count: acc.count + count,
              total: acc.total + total,
            };
          },
          { count: 0, total: 0 },
        );

      return `${equipmentTotal.count}/${equipmentTotal.total}`;
    },
    [visibleColumns],
  );

  const sparklineData = useMemo(
    () => buildSparklineData(seriesCache, selectedDate, EQUIP_COLS),
    [seriesCache, selectedDate],
  );

  const calendarMaxDate = useMemo(() => {
    const today = dayjs();
    if (inferredMeta?.isStale && inferredMeta.inferredEndDate) {
      const inferred = dayjs(inferredMeta.inferredEndDate);
      return inferred.isBefore(today) ? inferred : today;
    }
    return today;
  }, [inferredMeta]);

  const showStaleBanner =
    inferredMeta?.isStale &&
    !staleBannerDismissed &&
    sessionStorage.ondsid;

  const handleStepHourNext = useCallback(() => {
    const isToday = selectedDate === getTodayYYYYMMDD();
    const bound = getTimelineNowBound(isToday, TIMELINE_HOURS);
    const idx = TIMELINE_HOURS.indexOf(selectedHour);
    if (idx < 0 || idx >= bound.maxHourIdx) {
      setIsPlayingHour(false);
      return;
    }
    setSelectedHour(TIMELINE_HOURS[idx + 1]);
    setSelectedMinute(0);
  }, [selectedHour, selectedDate]);

  const handleStepMinuteNext = useCallback(() => {
    const isToday = selectedDate === getTodayYYYYMMDD();
    const bound = getTimelineNowBound(isToday, TIMELINE_HOURS);
    const max =
      isToday && selectedHour === bound.hour ? bound.maxMinute : 59;
    const cur = selectedMinute ?? 0;
    if (cur < max) {
      setSelectedMinute(cur + 1);
      return;
    }
    setIsPlayingMinute(false);
  }, [selectedHour, selectedMinute, selectedDate]);

  useEffect(() => {
    if (viewMode !== "hourly" || selectedDate !== getTodayYYYYMMDD()) return;
    const clamped = clampTimelineSelection(
      selectedHour,
      selectedMinute,
      true,
      TIMELINE_HOURS,
    );
    if (
      clamped.hour !== selectedHour ||
      clamped.minute !== (selectedMinute ?? 0)
    ) {
      setSelectedHour(clamped.hour);
      setSelectedMinute(clamped.minute);
      setIsPlayingHour(false);
      setIsPlayingMinute(false);
    }
  }, [viewMode, selectedDate, selectedHour, selectedMinute]);

  const handleCloseDisaster = async () => {
    const snum = inferredMeta?.snum || sessionStorage.onid;
    if (!snum || !window.confirm("이 재난을 종료 처리하시겠습니까?")) return;
    try {
      const response = await fetch(`${props.apiAddr}/get/dsend?id=${snum}`);
      const data = await response.json();
      if (data.result === "success") {
        if (String(snum) === String(sessionStorage.onid)) {
          sessionStorage.oningox = 0;
          props.onStatus?.(Math.random());
        }
        setInferredMeta((prev) =>
          prev ? { ...prev, isStale: false, dsox: "0" } : prev,
        );
        setStaleBannerDismissed(true);
        fetchInferredMeta();
      } else {
        alert("종료 처리 중 오류가 발생했습니다.");
      }
    } catch (e) {
      alert("종료 처리 중 오류가 발생했습니다.");
    }
  };

  const dismissStaleBanner = () => {
    const dsid = sessionStorage.ondsid;
    if (dsid) sessionStorage[`staleBannerDismiss_${dsid}`] = "1";
    setStaleBannerDismissed(true);
  };

  useEffect(() => {
    const dsid = sessionStorage.ondsid;
    if (dsid && sessionStorage[`staleBannerDismiss_${dsid}`] === "1") {
      setStaleBannerDismissed(true);
    } else {
      setStaleBannerDismissed(false);
    }
  }, [onSelectDS]);

  const renderDataCell = (item, columnId, isTotal = false) => {
    const val = isTotal ? calculateTotalCount(item) : item[columnId];
    if (!isTotal && val === "0/0") return "";
    const orgKey = item.org || "sum";
    const diff = isTotal
      ? diffMap[orgKey]?.total
      : diffMap[orgKey]?.[columnId];
    const highlight =
      (viewMode === "hourly" || viewMode === "live") && diff?.changed;
    return (
      <span
        style={{
          ...cellnum,
          ...(highlight ? { backgroundColor: "#fff9c4" } : {}),
        }}
      >
        {val}
        <DiffBadge diff={diff} />
      </span>
    );
  };

  // 2. 그 다음 mflist 정의
  // mfdata 배열의 각 항목을 기반으로 테이블 행을 생성하는 함수입니다.
  // 각 행은 기관 정보를 표시하며, 첫 번째 열은 기관 이름을, 두 번째 열은 장비의 총 수를 보여줍니다.
  // visibleColumns 배열을 통해 표시할 열을 동적으로 생성합니다.
  // 행정과 회복 데이터가 표출되지 않는 이유는 해당 항목들이 visibleColumns 배열에 포함되지 않기 때문입니다.
  // 이를 해결하기 위해 columns 배열에 행정과 회복 항목을 추가하고, checkColumnHasData 함수가 이들 항목에 대한 데이터를 확인하도록 수정해야 합니다.
  const mflist = mfdata.map((item) => (
    <TableRow
      key={item.org}
      sx={{
        "&:first-of-type td, &:first-of-type th": {
          fontWeight: "bold",
          backgroundColor: yellow[200],
        },
      }}
    >
      <TableCell
        component="th"
        scope="row"
        sx={{ fontStyle: "bold" }}
        bgcolor={teal[100]}
      >
        <Typography
          id={item.org}
          sx={sessionStorage.oningox == 1 ? rowstyle : rowstyleG}
          onClick={orgBtnClickHandler}
        >
          {item.org == "sum"
            ? "계"
            : item.org
                .trim()
                .replace(/본부|소방|안전|구조|재난|상|라|청|도|입력/g, "")}
        </Typography>
      </TableCell>
      <TableCell sx={dcell}>
        {(() => {
          const orgKey = item.org || "sum";
          const diff = diffMap[orgKey]?.total;
          const highlight =
            (viewMode === "hourly" || viewMode === "live") && diff?.changed;
          return (
            <span
              style={{
                ...cellnum,
                ...(highlight ? { backgroundColor: "#fff9c4" } : {}),
              }}
            >
              {calculateTotalCount(item)}
              <DiffBadge diff={diff} />
              {item.org === "sum" && viewMode === "hourly" && (
                <MiniSparkline data={sparklineData} />
              )}
            </span>
          );
        })()}
      </TableCell>
      {visibleColumns.map((column) => (
        <TableCell
          key={column.id}
          sx={dcell}
          bgcolor={column.isSupport ? bcd : undefined}
        >
          {renderDataCell(item, column.id)}
        </TableCell>
      ))}
    </TableRow>
  ));

  useEffect(() => {
    const t = setTimeout(() => {
      const statusPanel = document.getElementById("statusPanel");
      if (statusPanel) {
        // 상황판 top(70px) + 패널 높이 = 동원자원세부현황창이 붙을 위치
        sessionStorage.statusHeight = 70 + statusPanel.offsetHeight;
      }
    }, 100);
    return () => clearTimeout(t);
  }, [mfdata, checked]);

  const switchstyle = {
    backgroundColor: grey[200],
    marginRight: 1,
    marginLeft: 1,
    borderRadius: 3,
  };

  // 스위치 컨테이너 스타일 추가
  const switchContainer = {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  };

  const dividerStyle = {
    backgroundColor: "white",
    height: "20px",
    margin: "0 8px",
  };

  const statusHeaderCompact = {
    padding: "4px 10px",
    marginBottom: 0,
    marginTop: 0,
    height: 36,
    minHeight: 36,
    boxSizing: "border-box",
    alignItems: "center",
    display: "flex",
  };

  const sidebarExpanded = props.sidebarExpanded !== false;
  const statusLeft = sidebarExpanded ? "370px" : "180px";

  return (
    <Box
      sx={{
        position: "absolute",
        zIndex: 10,
        top: "70px",
        left: statusLeft,
        display: "flex",
        gap: 1,
        alignItems: "flex-start",
        transition: "left 0.25s ease-out",
      }}
      id="statusPanel"
    >
      <Box
        id="statusBoardBox"
        sx={{
          backgroundColor: teal[100],
          border: "solid 1px black",
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          overflow: "hidden",
          width: checked ? undefined : "auto",
          minWidth: checked ? undefined : "unset",
          maxHeight: checked ? undefined : "36px",
        }}
      >
        <Box
          id="tblcontainer"
          sx={{
            ...(sessionStorage.oningox == 1 ? statusTitle : statusTitleG),
            ...(!checked ? statusHeaderCompact : {}),
          }}
        >
          {checked && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <LightTooltip
                title="엑셀일괄입력"
                placement="top"
                arrow
                style={{ marginTop: "3px" }}
              >
                <UploadIcon
                  src={excel_up}
                  style={excelbtn}
                  onClick={excelUploadClickHandler}
                />
              </LightTooltip>
              <LightTooltip
                title="엑셀일괄입력 서식 다운로드"
                placement="top"
                arrow
                style={{ marginTop: "3px" }}
              >
                <ListIcon
                  variant="h5"
                  sx={{ marginLeft: "3px" }}
                  style={excelbtn}
                  onClick={docdownClickHandler}
                />
              </LightTooltip>
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              flexWrap: "wrap",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                margin: 0,
                ...(!checked ? { lineHeight: 1.25 } : {}),
              }}
            >
              상황판
            </Typography>
            {checked && (
              <Box
                component="button"
                type="button"
                onClick={(e) => {
                  setCalendarAnchorEl(e.currentTarget);
                  setCalendarViewDate(dayjs(selectedDate));
                  fetchDatesWithData(selectedDate.slice(0, 7));
                }}
                sx={{
                  border: "1px solid rgba(255,255,255,0.5)",
                  borderRadius: 1,
                  color: "white",
                  fontSize: "0.875rem",
                  padding: "6px 6px",
                  cursor: "pointer",
                  background: "transparent",
                  minWidth: 100,
                }}
              >
                {selectedDate}
              </Box>
            )}
            {checked && (
              <Popover
                open={Boolean(calendarAnchorEl)}
                anchorEl={calendarAnchorEl}
                onClose={() => setCalendarAnchorEl(null)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DateCalendar
                    value={calendarViewDate}
                    onChange={(d) => {
                      const picked = dayjs(d);
                      setCalendarViewDate(picked);
                      setSelectedDate(picked.format("YYYY-MM-DD"));
                      setCalendarAnchorEl(null);
                      const pickedStr = picked.format("YYYY-MM-DD");
                      if (showReview) {
                        setViewMode("hourly");
                        const clamped = clampTimelineSelection(
                          selectedHour ?? 9,
                          selectedMinute ?? 0,
                          pickedStr === getTodayYYYYMMDD(),
                          TIMELINE_HOURS,
                        );
                        setSelectedHour(clamped.hour);
                        setSelectedMinute(clamped.minute);
                      } else if (pickedStr === getTodayYYYYMMDD()) {
                        setViewMode("live");
                      } else {
                        setViewMode("daily");
                        setSelectedHour(9);
                      }
                      setIsPlayingHour(false);
                      setIsPlayingMinute(false);
                    }}
                    onMonthChange={(newMonth) => {
                      const nextMonth = dayjs(newMonth);
                      setCalendarViewDate((prev) => {
                        const base = prev && prev.isValid() ? prev : dayjs();
                        return base
                          .year(nextMonth.year())
                          .month(nextMonth.month());
                      });
                      fetchDatesWithData(dayjs(newMonth).format("YYYY-MM"));
                    }}
                    slots={{ day: ServerDay }}
                    slotProps={{
                      day: {
                        datesWithData,
                        inferredEndDate: inferredMeta?.inferredEndDate,
                      },
                    }}
                    maxDate={calendarMaxDate}
                    sx={{ mt: 1 }}
                  />
                </LocalizationProvider>
              </Popover>
            )}
            {checked && (
              <LightTooltip
                title="상황판 갱신"
                placement="top"
                arrow
                sx={{ zIndex: "100000" }}
              >
                <RefreshIcon
                  onClick={handleRefresh}
                  sx={{
                    color: yellow[600],
                    cursor: "pointer",
                    fontStyle: "bold",
                    fontSize: "1.5rem",
                    "&:hover": {
                      color: yellow[400],
                      transform: "rotate(360deg)",
                      transition: "transform 0.5s ease-in-out",
                    },
                  }}
                />
              </LightTooltip>
            )}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignContent: "middle",
            }}
          >
            <div style={switchContainer}>
              {checked && (
                <>
                  <LightTooltip
                    title="시간별 변화 리뷰 (재생·스크럽)"
                    placement="bottom"
                    arrow
                  >
                    <Button
                      size="small"
                      variant={showReview ? "contained" : "outlined"}
                      onClick={handleReviewToggle}
                      sx={{
                        minWidth: 44,
                        py: 0.2,
                        px: 0.9,
                        mr: 0.5,
                        fontSize: "0.68rem",
                        fontWeight: 700,
                        lineHeight: 1.3,
                        textTransform: "none",
                        color: showReview ? "#5d0000" : "#fff",
                        backgroundColor: showReview
                          ? "#ffca28"
                          : "rgba(255,255,255,0.1)",
                        borderColor: "rgba(255,255,255,0.5)",
                        "&:hover": {
                          backgroundColor: showReview
                            ? "#ffd54f"
                            : "rgba(255,255,255,0.2)",
                          borderColor: "#fff",
                        },
                      }}
                    >
                      리뷰
                    </Button>
                  </LightTooltip>
                  <Divider orientation="vertical" sx={dividerStyle} />
                </>
              )}
              {checked && ( // 상황판이 보일 때만 3줄 버튼 표시
                <>
                  <Switch
                    checked={showCompact}
                    onChange={(e) => setShowCompact(e.target.checked)}
                    sx={{
                      ...switchstyle,
                      "& .MuiSwitch-thumb": {
                        backgroundColor: showCompact ? blue[500] : grey[400],
                      },
                    }}
                    size="small"
                  />
                  <Typography
                    variant="caption"
                    sx={{
                      color: "white",
                      fontSize: "0.7rem",
                    }}
                  >
                    3줄
                  </Typography>
                  <Divider orientation="vertical" sx={dividerStyle} />
                </>
              )}
              <Switch
                checked={checked}
                onChange={handleChange}
                sx={{
                  ...switchstyle,
                  ...(!checked ? { marginLeft: 0.5, marginRight: 0 } : {}),
                }}
                size="small"
              />
            </div>
            {checked && (
              <LightTooltip
                title="엑셀 저장"
                placement="bottom"
                arrow
                style={{ marginTop: "3px", zIndex: 10 }}
              >
                <DownloadIcon
                  src={excel_down}
                  style={excelbtn}
                  onClick={tableToExcelExport}
                />
              </LightTooltip>
            )}
          </div>
        </Box>

        {checked && showStaleBanner && (
          <Box className={cls.staleBanner}>
            <span>
              추정 종료: <strong>{inferredMeta.inferredEndDate}</strong>
              {inferredMeta.staleDays > 0 &&
                ` (${inferredMeta.staleDays}일 전)`}{" "}
              · 재난 상태는 아직 <strong>진행</strong>입니다.
            </span>
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                size="small"
                variant="contained"
                color="error"
                onClick={handleCloseDisaster}
                sx={{ fontSize: "0.75rem", py: 0.25 }}
              >
                종료 처리
              </Button>
              <Button
                size="small"
                variant="outlined"
                onClick={dismissStaleBanner}
                sx={{ fontSize: "0.75rem", py: 0.25, borderColor: "#3e2723", color: "#3e2723" }}
              >
                닫기
              </Button>
            </Box>
          </Box>
        )}

        {checked && showReview && (
          <StatusTimelineBar
            selectedHour={selectedHour}
            onHourChange={setSelectedHour}
            selectedMinute={selectedMinute}
            onMinuteChange={setSelectedMinute}
            isPlayingHour={isPlayingHour}
            onPlayingHourChange={setIsPlayingHour}
            isPlayingMinute={isPlayingMinute}
            onPlayingMinuteChange={setIsPlayingMinute}
            changedHours={changedHours}
            changedMinutes={changedMinutes}
            isToday={selectedDate === getTodayYYYYMMDD()}
            onStepHourNext={handleStepHourNext}
            onStepMinuteNext={handleStepMinuteNext}
          />
        )}

        {checked && (
          <TableContainer
            component={Paper}
            sx={{
              maxHeight: showCompact ? "160px" : "800px", // 3줄 정도의 높이로 제한
              overflowY: "auto", // 스크롤바 추가
              backgroundColor: teal[100],
              "&::-webkit-scrollbar": {
                width: "8px",
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "4px",
              },
            }}
          >
            <Table
              sx={{
                maxHeight: 800,
                display: { xs: "none", sm: "block" },
              }}
              size="small"
              aria-label="a dense table"
              id="statusTable"
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
                  >
                    기관
                  </TableCell>
                  <TableCell
                    sx={sessionStorage.oningox == 1 ? tblstyle : tblstyleG}
                  >
                    <div style={{ lineHeight: "1" }}>
                      소방계
                      <br />
                      (장비/인원)
                    </div>
                  </TableCell>
                  {visibleColumns.map((column) => (
                    <TableCell
                      key={column.id}
                      sx={{
                        ...(sessionStorage.oningox == 1
                          ? column.isSupport
                            ? volbgc
                            : tblstyle
                          : column.isSupport
                            ? volbgcG
                            : tblstyleG),
                        paddingLeft: "1px",
                        paddingRight: "1px",
                      }}
                    >
                      <Typography sx={eqpBtn} onClick={eqpBtnHandler}>
                        {column.label}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {!isdata ? (
                  <TableRow>
                    <TableCell
                      colSpan={visibleColumns.length + 2}
                      align="center"
                    >
                      자료가 없습니다.
                    </TableCell>
                  </TableRow>
                ) : (
                  mflist
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <span id="result"></span>
      </Box>
      {props.apiAddr && (
        <RdvAttendancePanel
          apiAddr={props.apiAddr}
          refreshBrd={props.refreshBrd}
          fullswitch={props.fullswitch}
          requestOpenSupportPanel={props.requestOpenSupportPanel}
        />
      )}
    </Box>
  );
};
export default StatusPanel;
